<template>
  <div class="visionStyle">

    <!-- <br> -->

    <h1>A Vision for Silicon Valley's First <br>Open-Source, Competition-Grade & Lower-Cost Robotics System...</h1>

    <!-- <br> -->
    <ul style="list-style:disc;">
      <li>Since <scanBold>Co-Founding</scanBold> an <scanBold>Educational-Tech R&D Center</scanBold> -- <a href="http://www.eande.world/" class="urlLink" target="_blank" style="color:blue;text-decoration-line:underline;font-size:100%">Encourage and Empower (EandE)</a> -- in 2004 at my home/garage, I've enjoyed serving as <scanBold>Sr. Instructor and Curriculum-Engineer</scanBold> where we developed <scanBold>"T.A.C.H.nology® Robotics w/ Arduino & Raspberry Pi"</scanBold> as Silicon Valley's 1st Open-Source, Competition-Grade & Lower-Cost Alternative to LEGO®, TETRIX® & VEX® Robotics.</li>

      <li><scanBold>Innovations</scanBold> behind our Educational Robotics System include (more details, photos and short videos can be found at <a href="http://www.eande.world/" class="urlLink" target="_blank" style="color:blue;text-decoration-line:underline;font-size:100%">EandE</a>):
        <ul style="list-style:disc; margin-left:2em;">
          <li>Creative S.T.E.A.M.-Based Hardware-Chassis that integrates "T.echnology, A.rts & C.rafts... H.olistically" to inspire Industry-Grade Robotics to both Primary & Secondary School students, as showcased at <scanBold>San Jose's Tech Museum and Bay Area's Maker Faire Premier Showroom</scanBold> (campus attracted 100k+ spectators),</li>
          <li>Industry-Leading Cloud-Based Raspberry-Pi Remote-Control System (Python & C++) that helped lead to a <scanBold>1-year alliance with Siemens-eMeter in Foster City</scanBold> to collaborate on Web Full-Stack Technologies (JavaScript & Python) for their Cloud-Based Energy Smart-Grids, and</li>
          <li>Award-Winning Google-Based 'Blockly Drag-n-Drop' C++ Coding Editor (JavaScript & Python) that opened an opportunity to serve as <scanBold>Adjunct Professor for CS110 'C 'Programming at Cogswell Polytechnical College in San Jose</scanBold>.</li>
        </ul>
      </li>
      <li>These above experiences have inspired my R&D efforts at EandE to form the following <scanBold>Vision to Encourage and Empower</scanBold> our students regarding the <scanBold>#1 Hi-Tech Career Path… Web/Cloud Development <scanSlideRef>(refer below to Slide #1)</scanSlideRef></scanBold>.</li>          

    </ul>
    <!-- <br> -->


    <h1>...Inspires a Progressive Vision for<br>Students as 'Web/Cloud-Innovators' through Computer Science</h1>
    <!-- <br> -->

    <ul style="list-style:disc;">
      <li>As <scanBold>Open-Source Web/Cloud Technologies</scanBold> mature and become more mainstreamed into industry, students in Computer Science  -- especially for Colleges and Secondary Schools with limited resources -- are more freed from the previous struggle of playing 'catch-up' to a once 'closed-source, limited-access & high-cost' Hi-Tech field of the past.</li>
      <li>And by properly harnessing this global <scanBold>Open-Source Revolution</scanBold>, students can 1) be empowered to innovate with the 'best-of-the-best' world-wide -- regardless of age or socio-economic background -- and subsequently 2) be encouraged to give back to society through <scanBold>Open-Source Collaboration</scanBold>.</li>
      <li>Thus our students do not passively-settle as 'industry-learners' -- but rather -- actively-contribute as 'industry-innovators' in responsibly building a stronger community... for life.</li>
      <br>
      <li>Traditionally, I've enjoyed coding and teaching <scanBold>Java, C#, C++ & C</scanBold> -- among many other Linux-Based languages/toolsets.</li>
      <li>Yet due to the global pervasiveness of Web/Cloud-Services and Robotics, Stack Overflow's 2018 Global Survey of 100K Developers concludes that two Open-Source Languages -- <scanBold>JavaScript</scanBold> and <scanBold>Python</scanBold> -- have taken our world by 'storm', at least for these past several years <scanSlideRef>(Slide #2)</scanSlideRef>.</li>
      <li>Thus from our <a href="http://www.eande.world/" class="urlLink" target="_blank" style="color:blue;text-decoration-line:underline;font-size:100%">Encourage and Empower's (EandE) Instructional R&D Lab</a>  (as based at my home/garage since 2004), I wish to present this <scanBold>Online Portfolio</scanBold> of <scanBold>JavaScript & Python Curriculum-Based Projects</scanBold> to spark our <scanBold>Student's Innovation</scanBold> within the <scanBold>Open-Source Global-Ecosystem</scanBold>.</li>
      <br>
      
      <!-- <li style="margin-left:2em;">And within the popular JavaScript Ecosystem, the following Leading Technologies are showcased:
        <ul style="list-style:disc; margin-left:2em;">
          <li>For Web Front-end Development: React and Vue.js as Top 2 Frameworks in Popularity (Slides #3, #4 & #5.)</li>
          <li>For Web Back-end Development: Node.js as Industry's #1 De Facto Standard (Slide #6).</li>          
        </ul>
      </li> -->

      <li>And with regards to the <scanBold>Most Popular Ecosystem: JavaScript</scanBold> <scanSlideRef>(Slide #2)</scanSlideRef>, the following Web/Cloud Technologies are showcased:
        <ul style="list-style:disc; margin-left:2em;">
          <li>Front-end: <scanBold>React</scanBold> and <scanBold>Vue.js</scanBold> as Top 2 Frameworks in Popularity <scanSlideRef>(Slides #3, #4 & #5).</scanSlideRef></li>
          <li>Back-end: <scanBold>Node.js</scanBold> as Industry's #1 De Facto Standard <scanSlideRef>(Slide #6)</scanSlideRef>.</li>          
        </ul>
      </li>

    </ul>
    <!-- <br> -->

  
    <h1>World-Wide Software Development Trends:</h1>
    <!-- <br> -->

    <!-- NOTE: ':mouseDrag=false' NOT appear to work -->
    <!-- NOTE:  "paginationPadding" "paginationSize" "speed": 'Expected Number, got String.' Warning Yet Code is Correct and Working. Therefore ignore warning. -->
    <!-- <carousel :per-page="1" :autoplay="true" :navigationEnabled="true" :navigate-to="someLocalProperty" :mouse-drag="true"> -->
    <!-- Y <carousel :perPage="1" :autoplay="true" :loop="true" :navigationEnabled="true" :mouseDrag="false" paginationActiveColor="#42b983" paginationColor="#b2ebd1" paginationSize="5" easing="ease" speed="1000"> -->
    <!-- Y <carousel :perPage="1" :autoplay="true" :loop="true" :navigationEnabled="true" :mouseDrag="false" paginationActiveColor="#42b983" paginationColor="#b2ebd1" paginationSize="5" easing="linear" speed="1000"> -->
    <!-- YY <carousel :perPage=1 :autoplay=true :autoplayTimeout=5000 :loop=false :navigationEnabled=true :mouseDrag=false paginationActiveColor="#42b983" paginationColor="#b2ebd1" paginationSize=20 paginationPadding=20 easing="ease" speed=1000> -->
    <carousel :perPage=1 :autoplay=true :autoplayTimeout=5000 :loop=true :navigationEnabled=true :mouseDrag=false paginationActiveColor="#42b983" paginationColor="#b2ebd1" paginationSize=20 paginationPadding=10 easing="ease" speed=1000>

      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #1</scanSlideRef><br>Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,<br>Top 3 Developer-Types Share Only One Common Language: JavaScript</h2>
          <a href="https://insights.stackoverflow.com/survey/2018#developer-roles" class="urlLink-CarrouselHeader" target="_blank">[https://insights.stackoverflow.com/survey/2018#developer-roles]</a>
        </div>
        <!-- <img :src="/static/work/${project.category}/${project.slug}/${project.slug}_thumb.png"> -->
        <!-- <img :src="/static/work/robotics-dir/11h-ArduBlockly-EandE/11h-ArduBlockly-EandE_thumb.png"> -->
        <!-- <img :src="http\://image.iqing.in/recommend/613890e9-3e5d-4acd-afae-003201e1d86d.jpg-cover"> -->
        <!-- Y src="\static\work\robotics-dir\11h-ArduBlockly-EandE\11h-ArduBlockly-EandE_thumb.png"> -->
        <!-- NOTE: ':src' not work, possibly in a non-vue '<img>' -->
        <!-- Y <img src="/static/work/robotics-dir/11h-ArduBlockly-EandE/11h-ArduBlockly-EandE_thumb.png"> -->
        <img src="/static/work/vision-dir/Stackoverflow-DeveloperType-Survey.png">
      </slide>
      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #2</scanSlideRef><br>Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,<br>JavaScript, CSS, HTML (All Web-Based Tools) are Top 3 in Popularity</h2>
          <a href="https://insights.stackoverflow.com/survey/2018#most-popular-technologies" class="urlLink-CarrouselHeader" target="_blank">[https://insights.stackoverflow.com/survey/2018#most-popular-technologies]</a>
        </div>
          <img src="/static/work/vision-dir/Stackoverflow-MostPopularTech-JavaScript.png">
      </slide>
      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #3</scanSlideRef><br>Based on GitHub's 3-Year Star-Ratings of Top 3 JS Frameworks,<br>Vue.js #1 in Greatest Momentum (React #2)</h2>
          <a href="http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue" class="urlLink-CarrouselHeader" target="_blank">[http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue]</a>
          <br>
          <a href="https://bestof.js.org/tags/framework/trending/last-12-months" class="urlLink-CarrouselHeader" target="_blank">[https://bestof.js.org/tags/framework/trending/last-12-months]</a>
        </div>
          <img src="/static/work/vision-dir/BestOfJsDotOrg-UiFramework-GithubStars.png">
      </slide>
      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #4</scanSlideRef><br>Based on Worldwide 2017 Poll of 28,000 JS Developers,<br>Vue.js #1 in Potential Market for Training (React #2)</h2>
          <a href="https://stateofjs.com/2017/front-end/results/" class="urlLink-CarrouselHeader" target="_blank">[https://stateofjs.com/2017/front-end/results/]</a>
        </div>
          <img src="/static/work/vision-dir/VueVsReact-StateOfJsDotCom.png">
      </slide>
      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #5</scanSlideRef><br>Based on GitHub's 2017 Star-Ratings of All JS Projects,<br>Vue.js #1 in Popularity (React #2)</h2>
          <a href="https://risingstars.js.org/2017/en/#section-all" class="urlLink-CarrouselHeader" target="_blank">[https://risingstars.js.org/2017/en/#section-all]</a>
        </div>
          <img src="/static/work/vision-dir/VueVsReact-RisingStarsDotJsDotOrg.png">
      </slide>
      <slide>
        <div class="carouselHeader">
          <h2><scanSlideRef>Slide #6</scanSlideRef><br>Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,<br>Node.js #1 in Framework Popularity</h2>
          <a href="https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools" class="urlLink-CarrouselHeader" target="_blank">[https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools]</a>
        </div>
        <img src="/static/work/vision-dir/Stackoverflow-Framework-Node-Survey.png">
      </slide>
      
    </carousel>
    
  </div>
</template>

<script>
export default {
  name: 'VisionComponent',
  data () {
    return {
      jobs: this.$myStore.state.jobs,
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore
    }
  }
}
</script>

<style scoped lang="scss">

  $fontSize_Bullet: small;
  $fontSize_Header: large;
  $fontSize_Url: small;
  $backgroundColor_LightGrey: #d9d9d9;  // rgb(217, 217, 217);
  $backgroundColor_DarkGrey: #bbb;  // rgb(187, 187, 187);
  $backgroundColor_Black: #000000 ;  // rgba(0, 0, 0, 1)

  .urlLink {
    font-size: $fontSize_Url;
    color: blue;
    // Y margin-left: 3.5em;
    // margin-top: -0.5em;
    // margin-bottom: -0.5em;
    // text-align: right;
    // margin-left: 0.5em;
    text-decoration-line: underline;
  }
  .urlLink-CarrouselHeader {
    font-size: $fontSize_Url;
    color: blue;
    // Y margin-left: 3.5em;
    // margin-top: -0.5em;
    // margin-bottom: -0.5em;
    text-align: center;  // NOT APPEAR TO WORK, THUS NEED '.carouselHeader' maybe because <a> not work in this situation
    // margin-left: 0.5em;
    text-decoration-line: underline;
  }
  
  .carouselHeader{
    text-align: center;    
  }

  .fade-in {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-duration: 1s;
  }

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  scanBold {
    font-weight:500;
  } 
  scanSlideRef {
    color: red;
    font-weight:500;
  }

</style>



// WEBPACK FOOTER //
// Vision.vue?3c77b188